/*eslint-disable*/
import logoFooter from 'assets/img/home/logofooter.png';

// reactstrap components
import { Container } from 'reactstrap';
import { Row, Col } from 'antd';
import { isNotHeid } from 'constants/contantsFiles';

export default () => {
  return (
    <div style={{ marginTop: 32 }}>
      <Container>
        <Row gutter={[24, 24]} className='d-flex align-items-center justify-content-sm-center'>
          {isNotHeid && <Col lg={16}>
            <Row gutter={[24, 24]}>
              <Col sm={12} xs={24}>
                <div className='mb-2'>
                  <img style={{ width: 332, marginBottom: 10 }} alt='...' src={require('assets/img/brand/logo.png').default} />
                </div>
              </Col>
              <Col sm={12} xs={24}>
                <div>
                  <div style={{ fontSize: 12 }} className='mb-2'>
                    <i className='far fa-building'></i> 231 Nguyễn Văn Cừ - Phường 4 - Quận 5 - TP.HCM
                  </div>
                  <div style={{ fontSize: 12 }} className='mb-2'>
                    <i className='fas fa-phone'></i> (028) 73 035 556
                  </div>
                  <div style={{ fontSize: 12 }} className='mb-2'>
                    <i className='far fa-clock'></i> Thời gian làm việc (08:00 - 17:00)
                  </div>
                </div>
              </Col>
            </Row>
          </Col>}
          <Col lg={8}>
            <img src={logoFooter} style={{ height: 37 }} />
            <div className='copyright text-center text-xl-left text-muted'>
              © {new Date().getFullYear()}{' '}
              <a className='font-weight-bold ml-1 my-3' href='/'>
                Sách số
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
